import { Icon } from '../ui/primitives'

/**
 * Stands in for a routed module flagged `comingSoon` in app/routes.js: the real
 * screen renders underneath as a faded, inert preview so users can see what is
 * coming, with a Coming Soon card on top.
 */
export default function ComingSoon({ route, children }) {
  return (
    <div className="soon-wrap">
      <div className="soon-preview" inert aria-hidden="true">
        {children}
      </div>
      <div className="soon-overlay">
        <div className="soon-card">
          <div className="ai-logo"><Icon name={route.icon} /></div>
          <span className="soon-pill">Coming Soon</span>
          <h2>{route.title}</h2>
        </div>
      </div>
    </div>
  )
}
